import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Popup } from 'semantic-ui-react';

const Revert = (props) => {
    const {
        onChange,
        name,
        originalValue,
        standAlone,
        showWarning,
        className,
        shiftLeft,
        shiftDoubleLeft
    } = props;

    const revertValue = () => {
        if (showWarning && !confirm("Bent u zeker dat u de originele waarde wilt terug zetten?"))
            return;

        onChange({
            target: {
                name: name,
                value: originalValue
            }
        });
    };

    const undoClassName = className || (shiftLeft ? (shiftDoubleLeft ? "c-undo_shifted_double_left" : "c-undo_shifted_left") : "c-undo");

    return !standAlone ?
        <Popup trigger={<a className={classnames({ [undoClassName]: true })} onClick={revertValue}>
            <i className="fa fa-fw fa-undo"></i>
        </a>} content={'Keer terug naar vorige situatie'} />
        : <a onClick={revertValue}>
            <i className="fa fa-fw fa-undo"></i>
        </a>;
};

Revert.defaultProps = {
    shiftLeft: false,
    shiftDoubleLeft: false
};

Revert.propTypes = {
    onChange: PropTypes.func,
    name: PropTypes.string,
    originalValue: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string,
        PropTypes.array,
        null
    ]),
    standAlone: PropTypes.bool,
    showWarning: PropTypes.bool,
    className: PropTypes.string,
    shiftLeft: PropTypes.bool,
    shiftDoubleLeft: PropTypes.bool
};

export default Revert;